import { HttpResult } from "widgets-for-react"
import { CollectionClient, CollectionItem } from "./generated"
import { httpResult } from "./utils"

const client = new CollectionClient(window.location.origin)

export const fetchCollectionItem: (isbn: string) => () => Promise<HttpResult<CollectionItem>> = (isbn: string) => () => httpResult(async () => {
  const result = await client.getTitleByISBN(isbn)
  return result.Result;
})
